
import AppHeader from '../components/AppHeader';
import React, { useEffect, useRef, useState } from 'react';
import {
  getAllLogistics,
  getEntrySummary,
  getEntryById,
  downloadEntryExcel,
  getAllVials
} from '../services/logisticsService';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
  import Select from 'react-select';

function LogisticsAdminPage() {
  const [logisticsList, setLogisticsList] = useState([]);
  const [selectedLogisticsId, setSelectedLogisticsId] = useState('');
  const [entryDate, setEntryDate] = useState(new Date().toISOString().split('T')[0]);
  const [summaryList, setSummaryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const navigate = useNavigate();

  const [vialColorMap, setVialColorMap] = useState({});




  const dateInputRef = useRef(null);
  useEffect(() => {
    fetchLogistics();
    fetchSummary();
  }, []);

  const fetchLogistics = async () => {
    try {
      const res = await getAllLogistics();
      setLogisticsList(res.data?.data || []);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load logistics list');
    }
  };

  const handleViewEntry = async (entryId) => {
    try {
      setDetailLoading(true);
      setError('');

      const res = await getEntryById(entryId);
      setSelectedEntry(res.data?.data || null);
      fetchVials();
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load entry details');
    } finally {
      setDetailLoading(false);
    }
  };

  const fetchSummary = async (customParams = {}) => {
    try {
      setLoading(true);
      setError('');

      const params = {
        entryDate: customParams.entryDate ?? entryDate,
        logisticsId: customParams.logisticsId ?? selectedLogisticsId,
      };

      if (!params.logisticsId) {
        delete params.logisticsId;
      }

      const res = await getEntrySummary(params);
      setSummaryList(res.data?.data || []);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load entry summary');
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (date, logisticsId) => {
    const selectedDate = date || entryDate;
    const selectedLogistics = logisticsId ?? selectedLogisticsId;

    if (!selectedDate) {
      setError('Please select a date');
      return;
    }

    setSelectedEntry(null);

    fetchSummary({
      entryDate: selectedDate,
      logisticsId: selectedLogistics || undefined,
    });
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloadLoading(true);
      setError('');

      const params = {
        entryDate,
        logisticsId: selectedLogisticsId,
      };

      if (!params.logisticsId) {
        delete params.logisticsId;
      }

      const response = await downloadEntryExcel(params);

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'logistics-entry.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to download Excel');
    } finally {
      setDownloadLoading(false);
    }
  };




  useEffect(() => {
    fetchLogisticsList();
  }, []);

  const fetchLogisticsList = async () => {
    try {
      const response = await getAllLogistics();
      const result = response.data;

      if (result?.status === 1) {
        setLogisticsList(result.data || []);
      } else {
        setLogisticsList([]);
      }
    } catch (error) {
      setLogisticsList([]);
      console.log(error);
    }
  };


  const totalRows = summaryList.length;

  const totalClientsCount = summaryList.reduce((sum, row) => {
    return sum + Number(row.totalClients || 0);
  }, 0);

  const totalVialsCount = summaryList.reduce((sum, row) => {
    return sum + Number(row.totalVials || 0);
  }, 0);

    const fetchVials = async () => {
    try {
      const response = await getAllVials();

      const map = {};

      response.data.data.forEach((vial) => {
        map[vial.id] = vial.color_code;
      });

      setVialColorMap(map);
    } catch (err) {
      console.error('Error fetching vials', err);
    }
  };

// useEffect(() => {
//   const fetchVials = async () => {
//     try {
//       const response = await getAllVials();

//       // assuming response.data = [{ id, color_code }]
//       const map = {};

//       response.data.forEach((vial) => {
//         map[vial.id] = vial.color_code;
//       });

//       console.log('mappppppppp', response)
//       setVialColorMap(map);
//     } catch (err) {
//       console.error('Error fetching vials', err);
//     }
//   };

//   fetchVials();
// }, []);

  const detailMatrix = React.useMemo(() => {
    if (!selectedEntry?.items?.length) {
      return { clients: [], vials: [] };
    }

    const vialMap = new Map();
    const clientMap = new Map();

    selectedEntry.items.forEach((item) => {
      if (!vialMap.has(item.vialId)) {
        vialMap.set(item.vialId, {
          vialId: item.vialId,
          vialName: item.vialName,
        });
      }

      if (!clientMap.has(item.clientId)) {
        clientMap.set(item.clientId, {
          clientId: item.clientId,
          clientName: item.clientName,
          clientCode: item.clientCode,
          counts: {},
        });
      }

      const clientRow = clientMap.get(item.clientId);
      clientRow.counts[item.vialId] = item.qty;
    });

    return {
      clients: Array.from(clientMap.values()),
      vials: Array.from(vialMap.values()),
    };
  }, [selectedEntry]);

  const formatDateTime = (value) => {
    if (!value) return '';

    const d = new Date(value);

    return d.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };




const logisticsOptions = [
  { value: '', label: 'All Logistics' },
  ...logisticsList.map((item) => ({
    value: item.id,
    label: `${item.name}${item.code ? ` (${item.code})` : ''}`,
  })),
];

<div style={filterGroupStyle}>
  <Select
    options={logisticsOptions}
    value={
      logisticsOptions.find(
        (option) => String(option.value) === String(selectedLogisticsId)
      ) || logisticsOptions[0]
    }
    onChange={(selectedOption) => {
      const logisticsId = selectedOption?.value || '';
      setSelectedLogisticsId(logisticsId);
      handleFilter(entryDate, logisticsId);
    }}
    placeholder="Search Logistics..."
    isSearchable
    styles={{
      control: (provided) => ({
        ...provided,
        minHeight: '44px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        boxShadow: 'none',
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999,
      }),
    }}
  />
</div>

  return (
    <div style={pageStyle}>
      <AppHeader />
      <div style={heroBoxStyle}>
        <h2 style={{ margin: 0 }}>Logistics Admin Dashboard</h2>
        <p style={{ marginTop: '8px', color: '#475569' }}>
          Search submitted entries, view full details, and download Excel reports.
        </p>
      </div>

      <div style={statsGridStyle}>
        <div style={statCardStyle}>
          <p style={statLabelStyle}>Completed Rounds</p>
          <h3 style={statValueStyle}>{totalRows}</h3>
        </div>

        <div style={statCardStyle}>
          <p style={statLabelStyle}>Total Clients</p>
          <h3 style={statValueStyle}>{totalClientsCount}</h3>
        </div>

        <div style={statCardStyle}>
          <p style={statLabelStyle}>Total Vials</p>
          <h3 style={statValueStyle}>{totalVialsCount}</h3>
        </div>
      </div>

      {error && (
        <div style={errorBoxStyle}>
          {error}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'end', gap: '15px', flexWrap: 'wrap' }}>
        {/* <div> */}
        {/* <label style={labelStyle}>
            Entry Date <span style={{ color: '#dc2626' }}>*</span>
          </label> */}


      <DatePicker
        selected={entryDate ? new Date(entryDate) : null}
        onChange={(date) => {
          const formatted = date
            ? new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]
            : '';
          setEntryDate(formatted);
          handleFilter(formatted, selectedLogisticsId);
        }}
        maxDate={new Date()}
        dateFormat="dd/MM/yyyy"
        placeholderText="Select date"
        customInput={
      <input
            style={{
              width: '220px',
              height: '42px',
              padding: '0 12px',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              background: '#ffffff',
              color: '#0f172a',
              fontSize: '14px',
              outline: 'none',
            }}
          />
        }
      />

        <div style={filterGroupStyle}>
          {/* <label style={labelStyle}>Logistics</label> */}
          {/* <select
            value={selectedLogisticsId}
            onChange={(e) => {
              const logisticsId = e.target.value;
              setSelectedLogisticsId(logisticsId);
              handleFilter(entryDate, logisticsId);
            }}
            style={inputStyle}
          >
            <option value="">All Logistics</option>

            {logisticsList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name} {item.code ? `(${item.code})` : ''}
              </option>
            ))}
          </select> */}

          <Select
  options={logisticsOptions}
  value={
    logisticsOptions.find(
      (option) => String(option.value) === String(selectedLogisticsId)
    ) || logisticsOptions[0]
  }
  onChange={(selectedOption) => {
    const logisticsId = selectedOption?.value || '';
    setSelectedLogisticsId(logisticsId);
    handleFilter(entryDate, logisticsId);
  }}
  placeholder="Search Logistics..."
  isSearchable
  styles={{
    control: (provided) => ({
      ...provided,
      minHeight: inputStyle.height || '44px',
      borderRadius: inputStyle.borderRadius || '8px',
      border: inputStyle.border || '1px solid #ccc',
      backgroundColor: inputStyle.backgroundColor || '#fff',
      fontSize: inputStyle.fontSize || '14px',
      padding: '0 4px',
      boxShadow: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#888',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  }}
/>
        </div>
        {/* <p style={{ marginTop: '8px', fontSize: '13px', color: '#64748b' }}>
            Select one date to view completed rounds and vial counts for that day.
          </p> */}
        {/* </div> */}
        {/* <button onClick={handleFilter} style={buttonStyle}>
          Search
        </button> */}



        {/* <button
          onClick={handleClearFilters}
          style={{
            ...buttonStyle,
            backgroundColor: '#475569',
          }}
        >
          Clear Filters
        </button> */}

        <button
          onClick={handleDownloadExcel}
          disabled={downloadLoading}
          style={{
            ...buttonStyle,
            backgroundColor: '#166534',
            opacity: downloadLoading ? 0.7 : 1,
          }}
        >
          {downloadLoading ? 'Downloading...' : 'Download Excel'}
        </button>
      </div>

      {loading ? (
        <p>Loading summary...</p>
      ) : (
        <>
          <div style={tableWrapperStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Round ID</th>
                  <th style={thStyle}>Date</th>
                  <th style={thStyle}>Logistics</th>
                  <th style={thStyle}>Code</th>
                  <th style={thStyle}>Clients</th>
                  <th style={thStyle}>Total Vials</th>
                  <th style={thStyle}>Submitted At</th>
                </tr>
              </thead>
              <tbody>
                {summaryList.length > 0 ? (
                  summaryList.map((row) => (
                    <tr
                      key={row.entryId}
                      onClick={() => handleViewEntry(row.entryId)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor:
                          selectedEntry?.entryId === row.entryId ? '#eff6ff' : '#ffffff',
                      }}
                    >
                      <td style={tdStyle}>{row.entryId}</td>
                      <td style={tdStyle}> {new Date(row.entryDate).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
                      <td style={tdStyle}>{row.logistics?.name}</td>
                      <td style={tdStyle}>{row.logistics?.code}</td>
                      <td style={tdStyle}>{row.totalClients}</td>
                      <td style={tdStyle}>{row.totalVials}</td>
                      <td style={tdStyle}>{formatDateTime(row.submittedAt)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={tdStyle} colSpan="7">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {detailLoading && <p style={{ marginTop: '20px' }}>Loading entry details...</p>}

          {selectedEntry && !detailLoading && (
            <div style={detailBoxStyle}>
              <div style={{ marginTop: '16px' }}>

              </div>

              <h3>Entry Details</h3>
              <p><strong>Round ID:</strong> {selectedEntry.entryId}</p>
              <p><strong>Entry Date:</strong>  {new Date(selectedEntry.entryDate).toLocaleDateString('en-GB').replace(/\//g, '-')} </p>
              <p><strong>Submitted At:</strong> {formatDateTime(selectedEntry.submittedAt)}</p>
              <p><strong>Logistics:</strong> {selectedEntry.logistics?.name}</p>
              <p><strong>Code:</strong> {selectedEntry.logistics?.code}</p>

              <div style={{ marginTop: '16px', overflowX: 'auto', whiteSpace: 'nowrap', }}>
                <table style={tableStyle}>
                  <thead>
                    <tr>
                      <th style={thStyle}>Client</th>
                      <th style={thStyle}>Client Code</th>
                      {detailMatrix.vials.map((vial) => (
                      <th key={vial.vialId} style={thStyle}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '8px',
                          }}
                        >
                          <span>{vial.vialName}</span>

                          <span
                            title={vialColorMap[vial.vialId]}
                            style={{
                              width: '14px',
                              height: '14px',
                              backgroundColor: vialColorMap[vial.vialId] || '#ccc',
                              borderRadius: '3px',
                              border: '1px solid #ccc',
                              display: 'inline-block',
                              flexShrink: 0,
                            }}
                          ></span>
                        </div>
                      </th>
                    ))}
                    </tr>
                  </thead>
                  <tbody>
                    {detailMatrix.clients.map((client) => (
                      <tr key={client.clientId}>
                        <td style={tdStyle}>{client.clientName}</td>
                        <td style={tdStyle}>{client.clientCode}</td>
                        {detailMatrix.vials.map((vial) => (
                          <td key={vial.vialId} style={tdStyle}>
                            {client.counts[vial.vialId] ?? 0}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}



const heroBoxStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  padding: '20px',
  marginBottom: '20px',
};

const errorBoxStyle = {
  marginTop: '16px',
  padding: '12px 16px',
  backgroundColor: '#fee2e2',
  color: '#991b1b',
  borderRadius: '8px',
  border: '1px solid #fecaca',
};

const dateInputStyle = {
  width: '200px',
  height: '42px',
  padding: '0 12px',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  background: '#ffffff',
  color: '#0f172a',
  fontSize: '14px',
  cursor: 'pointer',
  outline: 'none',
};
const filterGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  minWidth: '180px',
};


const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
};

const inputStyle = {
  // width: '100%',
  padding: '10px 12px',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  fontSize: '14px',
};


const buttonStyle = {
  fontFamily: '"Mulish", sans-serif',
  padding: '10px 16px',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: '#0f172a',
  color: '#ffffff',
  cursor: 'pointer',
};

const tableWrapperStyle = {
  whiteSpace: 'nowrap',
  marginTop: '20px',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  overflowX: 'auto',
  padding: '16px',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

const thStyle = {
  border: '1px solid #e2e8f0',
  padding: '12px',
  backgroundColor: '#f8fafc',
  textAlign: 'left',
};

const tdStyle = {
  border: '1px solid #e2e8f0',
  padding: '12px',
};

const detailBoxStyle = {
  marginTop: '24px',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  padding: '16px',
};

const statsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '16px',
  marginBottom: '20px',
};

const pageStyle = {
  padding: '24px',
  maxWidth: '1400px',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const statCardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  padding: '18px',
};

const statLabelStyle = {
  margin: 0,
  color: '#64748b',
  fontSize: '14px',
};

const statValueStyle = {
  margin: '10px 0 0 0',
  fontSize: '28px',
  color: '#0f172a',
};

export default LogisticsAdminPage;